import { ArticleOrBriefing } from '@components/Feed/ArticleOrBriefingFeedItem';
import { api_search_entities_path, api_search_path } from '@routes';

import request from './request';
import { PaginationType } from './subscriber_directory';

export enum SortOption {
  Recent = 'recent',
  Relevant = 'relevant',
}

export enum Scope {
  Articles = 'articles',
  Forum = 'forum',
  Directory = 'directory',
}

export interface TopRelatedEntity {
  name: string;
  matchingEntity: boolean;
}

export interface SearchParams {
  query: string;
  sort?: SortOption;
  page?: number;
  scope?: Scope;
}

export interface SearchResponse extends PaginationType {
  content: ArticleOrBriefing[];
  error?: string;
  pageCount: number;
  query: string;
  totalResults: number;
}

export interface SearchEntitiesResponse {
  topRelatedEntities: TopRelatedEntity[];
}

export async function searchArticles({
  query,
  sort = SortOption.Relevant,
  page = 1,
  scope = Scope.Articles,
}: SearchParams): Promise<SearchResponse> {
  const resp = await request('get', api_search_path(), {
    query,
    sort,
    page,
    scope,
  });
  return resp;
}

export async function searchEntities({ query }: SearchParams): Promise<SearchEntitiesResponse> {
  const resp = await request('get', api_search_entities_path(), {
    query,
  });
  return resp;
}
